import React from 'react';
import { StepWrapper } from '../StepWrapper';
import { Integrations } from '@/pages/Integrations';

interface StepCompanySetupProps {
  onNext: () => void;
  onSkip: () => void;
}

export function StepCompanySetup({ onNext, onSkip }: StepCompanySetupProps) {
  return (
    <StepWrapper
      onNext={onNext}
      onSkip={onSkip}
      nudgeMessage="Adding companies activates your integrations and triggers the sync of projects and resources into the planner."
    >
      {/* Padding wrapper — Integrations uses space-y-6 w-full, no h-full dependency */}
      <div className="p-6">
        <Integrations />
      </div>
    </StepWrapper>
  );
}
